"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `customers/user/`;
